import { render, staticRenderFns } from "./workforce_analysis.vue?vue&type=template&id=cc6b64f2&scoped=true"
import script from "./workforce_analysis.vue?vue&type=script&lang=js"
export * from "./workforce_analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6b64f2",
  null
  
)

export default component.exports